import { render, staticRenderFns } from "./Issues-comp.vue?vue&type=template&id=d23f907e&"
import script from "./Issues-comp.vue?vue&type=script&lang=js&"
export * from "./Issues-comp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports